import { useMutation } from "react-query";
import http from "infra/http";

function useExcluirImposto() {
    return useMutation(
        (id: string) => {
            return http.delete(`/v1/imposto/${id}`);
        },
        { retry: false }
    );
}

export default useExcluirImposto;
